import { useScreenSize } from 'src/customHooks/customHooks'
import {
  PASQComponentFirstPart,
  PSAQCActionButton,
  PSAQCContainer,
  PSAQCFirstPartComponentWrapper,
  PSAQMentorImage,
} from './PSAQCStyles'

import { getImageLink } from 'src/mentor/helpers/utilityFunctions'

export default function PersonSayingAQuoteCard({
  primaryQuoteComponent,
  sideNote,
  personImage,
  personName,
  personCreds,
  actionButtonData = {
    text: 'READY TO START YOUR JOURNEY?',
    onClick: () => {},
  },
}) {
  const { width, height } = useScreenSize()

  return (
    <PSAQCContainer>
      <PASQComponentFirstPart className="d-flex flex-column gap-4">
        <PSAQCFirstPartComponentWrapper>{primaryQuoteComponent}</PSAQCFirstPartComponentWrapper>
        <PSAQCActionButton onClick={actionButtonData.onClick}>
          {actionButtonData.text}
        </PSAQCActionButton>
      </PASQComponentFirstPart>
      <PSAQMentorImage
        src={getImageLink('MEDIA-483f5646d0c24f23b86e67923cb08ca4')}
        // src={infiniteAddictionMentors}
        alt="mentors"
      />
    </PSAQCContainer>
  )
}

export const PrimaryQuoteComponent = () => {
  return (
    <>
      <span>Have someone with you, who is </span>
      <span style={{ color: '#6655ab' }}>100% invested </span>
      <span>in your success</span>
    </>
  )
}
